import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 集保(TDCC) - 取得 TxID
 */
const GetTdccTXID = [
    'POST',
    RouteUrlList.API_TdccGetTXID.path,
    {},
    200,
    {
        status: true,
        title: '取得集保 TxID 成功',
        message: '',
        errorCode: '',
        result: {
            txID: '12345678-1234-1234-1234-123456789abc',
            tdccRedirectUrl: 'https://tdcc.example.com/Redirect?txid=12345678-1234-1234-1234-123456789abc&callback=https%3A%2F%2Flocalhost%3A7288%2FTdccCallback%3Ftoken%3Dabc123'
        }
    }
];

export default GetTdccTXID;
